<template>
  <v-combobox
      v-model="selectedStands"
      deletable-chips
      hide-details
      :items="items"
      label="Stands"
      multiple
      small-chips
      clearable
      dense
      flat
      hide-no-data
      outlined
  >
  </v-combobox>
</template>

<script>

export default {
  name: 'StandSelect',
  props: {
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  computed: {
    selectedStands: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
  }
}
</script>
